<template>
  <b-container>
    <!-- nomeAcesso -->
    <b-form-group label="Nome acesso" label-for="input-nomeAcesso">
      <b-form-input
        v-if="readonly == true"
        type="text"
        id="input-nomeAcesso"
        placeholder="Informe o nome de acesso"
        v-model="form.nomeAcesso"
        readonly
      />
      <b-form-input
        v-else
        type="text"
        id="input-nomeAcesso"
        placeholder="Informe o nome de acesso"
        v-model="form.nomeAcesso"
      />
      <span class="text-danger" v-if="modelstate['NomeAcesso']">{{
        modelstate["NomeAcesso"][0]
      }}</span>
    </b-form-group>

    <!-- senhaAcesso -->
    <b-form-group
      v-if="!readonly"
      label="Senha acesso"
      label-for="input-senhaAcesso"
    >
      <b-form-input
        type="text"
        id="input-senhaAcesso"
        placeholder="Informe a senha"
        v-model="form.senhaAcesso"
      />
      <span class="text-danger" v-if="modelstate['SenhaAcesso']">{{
        modelstate["SenhaAcesso"][0]
      }}</span>
    </b-form-group>
    <!-- {{readonly}} -->
    <!-- nomeApresentacao -->
    <b-form-group
      label="Nome de apresentação"
      label-for="input-nomeApresentacao"
    >
      <b-form-input
        type="text"
        id="input-nomeApresentacao"
        placeholder="Informe o nome de apresentação"
        v-model="form.nomeApresentacao"
      />
      <span class="text-danger" v-if="modelstate['NomeApresentacao']">{{
        modelstate["NomeApresentacao"][0]
      }}</span>
    </b-form-group>

    <!-- email -->
    <b-form-group label="E-mail" label-for="input-email">
      <b-form-input
        type="text"
        id="input-email"
        placeholder="Informe o e-mail"
        v-model="form.email"
      />
      <span class="text-danger" v-if="modelstate['Email']">{{
        modelstate["Email"][0]
      }}</span>
    </b-form-group>

    <!-- DocumentNumber -->
    <b-form-group label="CPF:" label-for="input-DocumentNumber">
      <b-form-input
        type="text"
        id="input-DocumentNumber"
        placeholder="CPF da pessoa"
        v-model="form.documentNumber"
        v-mask="'999.999.999-99'"
      />
      <span class="text-danger" v-if="modelstate['DocumentNumber']">{{
        modelstate["DocumentNumber"][0]
      }}</span>
    </b-form-group>

    <!-- celular -->
    <b-form-group label="Celular:" label-for="input-celular">
      <b-form-input
        type="text"
        id="input-celular"
        placeholder="Informe o celular da empresa"
        v-model="form.celular"
        v-mask="'(99) 99999-9999'"
      />
      <span class="text-danger" v-if="modelstate['Celular']">{{
        modelstate["Celular"][0]
      }}</span>
    </b-form-group>

    <!-- telefoneComercial -->
    <b-form-group label="Telefone" label-for="input-telefone">
      <b-form-input
        type="text"
        id="input-telefone"
        placeholder="Informe o telefone"
        v-model="form.telefone"
        v-mask="'(99) 9999-9999'"
      />
      <span class="text-danger" v-if="modelstate['Telefone']">{{
        modelstate["Telefone"][0]
      }}</span>
    </b-form-group>

    <!-- Perfil -->
    <b-form-group label="Perfil" label-for="profileId">
      <ProfileDropdownModal id="profileId" :profileId.sync="form.profileId" />
      <span class="text-danger" v-if="modelstate['ProfileUser']">
        {{ modelstate["ProfileUser"][0] }}
      </span>
    </b-form-group>

    <!-- ForceChangePassword -->
    <b-form-group label="Forçar troca de senha" label-for="profileId">
      <b-form-select
        :options="optionsBoolean"
        v-model="form.forceChangePassword"
      >
      </b-form-select>
    </b-form-group>

    <div>
      <b-form-group label-for="type" label="Tipo de usuário">
        <b-form-select
          :options="userType"
          v-model="form.userType"
        >
        </b-form-select>
      </b-form-group>
    </div>

    <b-form-group label="Observação" label-for="input-note">
      <b-form-textarea
        id="input-note"
        v-model="form.note"
        placeholder="Adicione uma observação..."
        @click="typingStart"
      />
      <span class="text-danger" v-if="modelstate['Note']">{{
        modelstate["Note"][0]
      }}</span>
    </b-form-group>
    <div v-if="isTyping">
      <b-row>
        <b-col class="text-right">
          <span v-if="isNoteValid">{{ noteLength }}/255</span>
          <span v-else class="text-danger"
            >Observação maior que o permitido. {{ noteLength }}/255</span
          >
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "ProfileCrudData",
  directives: {
    mask: AwesomeMask,
  },
  components: {
    ProfileDropdownModal: () =>
      import("@/components_rms/System/Profile/ProfileDropdownModal.vue"),
  },
  props: {
    form: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      isTyping: false,
      userType: [
        { value: 0, text: "Normal" },
        { value: 1, text: "Motorista" },
        { value: 2, text: "Operador" },
        { value: 3, text: "Frentista" },
      ],
    };
  },
  computed: {
    noteLength() {
      if (!this.form.note) return 0;
      return this.form.note.length;
    },
    isNoteValid() {
      return this.noteLength <= 255;
    },
  },
  methods: {
    typingStart() {
      this.isTyping = true;
    },
  },
};
</script>
